import { lazy, Suspense } from 'react'
import { ScreenState } from '../app/ScreenState.js'

/**
 * The route table's one line into this lane. Pixi and the host chunk load only when the child
 * actually opens `/oyun/:gameId` (ARCHITECTURE §9, PERF-05), so the app shell never carries
 * them.
 */
const GameHostScreen = lazy(() =>
  import('./GameHostScreen.js').then((module) => ({ default: module.GameHostScreen })),
)

export function GameHostRoute() {
  return (
    <Suspense
      fallback={
        <ScreenState status="loading" onRetry={() => window.location.reload()}>
          {null}
        </ScreenState>
      }
    >
      <GameHostScreen />
    </Suspense>
  )
}
